export default __webpack_public_path__ + "static/Ice-climbing-Colorado-b6ac74488ec0c3996b19b1c751a8f8d9.jpg";